import { DirectoryTreeType } from "../config/config";
import { IGraphSearchPager } from "./IGraphSearchPager";
import { IFolderLocation, ISharepointDocumentLocation } from "./ISharepointDocument";
import { ITeamChannelLocationDto } from "./services/ITeamChannelDto";

export interface ISiteInfo {
    id: string;
    name: string;
    webUrl: string;
    isSubsite: boolean;
    siteName?: string;
    key?: string;
    isTeam?: boolean;
    isSharedTeam?: boolean;
    isSite?: boolean;
    isHub?: boolean;
    hubId?: string;
    parentHubId?: string;
    description?: string;
    createdDateTime?: Date;
    lastModifiedDateTime?: Date;
    tessProjectId?: string;
    isManagedGroup?: boolean;
    /** The synthetic container that holds a group site's client-group members (see clientGroupTreeNode). */
    isClientGroup?: boolean;
    /** A site listed inside such a container. Its expansion shows its own content only, never
     * containers of its own, which bounds the tree's depth and skips the client-list lookup. */
    inClientGroup?: boolean;
    isManaged?: boolean;
    managedGroup?: string;
    isHubChild?: boolean;
    isInactive?: boolean;
}

export interface ISiteInfoUrl extends ISiteInfo {
    webUrl: string;
    isTeam?: boolean;
    isChannel?: boolean;
    teamSiteId?: string;
}

export interface ISubSiteInfo {
    id: string;
    name: string;
    webUrl: string;
    parentSiteId: string;
}

export interface ISiteInfoLocation extends ISiteInfo {
    canExpand?: boolean;
    expanded?: boolean;
    channels?: ITeamChannelLocationDto[];
    subSites?: ISiteInfoLocation[];
    subSitesNextHref?: string;
    documents?: ISharepointDocumentLocation[];
    folders?: IFolderLocation[];
    parentId?: string;
    treeType?: DirectoryTreeType;
    level?: number;
    isLoading?: boolean;
    loaded?: boolean;
    isSelected?: boolean;
    teamGroupId?: string;
    teamDriveId?: string;
    siteId?: string;
    randomId: string;
}

export interface ISiteSearchRequest {
    query?: string;
    from?: number;
    size?: number;
    hubSitesOnly?: boolean;
    allowedSites?: string[];
    hubSiteIds?: string[];
    pageLimit?: number;
    hubChildrenOnly?: boolean;
}

export interface ISiteSearchResult {
    sites: ISiteInfo[];
    pageData: IGraphSearchPager;
}

export const mapSites = (site: any): ISiteInfo => {
    return {
        id: site.id,
        name: site.displayName,
        description: site.description,
        webUrl: site.webUrl,
        siteName: site.name,
        isSite: true,
        isSubsite: false,
        createdDateTime: site.createdDateTime,
        lastModifiedDateTime: site.lastModifiedDateTime
    }
};

export const mapSubSites = (site: any): ISiteInfo => {
    return {
        id: site.id,
        name: site.displayName,
        description: site.description,
        webUrl: site.webUrl,
        siteName: site.name,
        isSite: true,
        isSubsite: true
    }
};

export const filterNonTopLevelSites = (site: any, index: number, siteArray: any[]): boolean => {
    if (!site.root) {
        return genericSiteTopLevelPathPredicate(site, siteArray);
    }
    return true;
}

export const filterNonTopLevelISiteInfoArray = (site: ISiteInfo, index: number, siteArray: ISiteInfo[]): boolean => {
    if (site?.isSubsite) {
        return genericSiteTopLevelPathPredicate(site, siteArray);
    }
    return true;
}

const genericSiteTopLevelPathPredicate = (site: ISiteInfo, siteArray: ISiteInfo[]): boolean => {
    const siteWebUrlParts: string[] = site?.webUrl?.split("/");
    if (Array.isArray(siteWebUrlParts) && siteWebUrlParts.length > 0) {
        siteWebUrlParts.pop();
        const parentWebUrl = siteWebUrlParts.join("/");
        if (siteArray.some(s => s.webUrl === parentWebUrl)) {
            return false;
        }
    }
    return true;
}